module.exports = __webpack_public_path__ + "images/emoji/secret.40d59ee635b08e7ebd3d.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/secret.png
// module id = GYFw
// module chunks = 1